import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface TransferTipFilters {
  nickName: string
  usedBy: string
  groupId: number | string
  belongEmpId: string
  belongCorpId: number | string
  createdTime?: string[]
  thirdParty: string
  sourceLabel: string
  takeoverStatus: number | string
}

export interface TransferTipRecord {
  avatar?: string
  nickName: string
  userId: string
  belongEmpId: string
  usedBy: string
  groupName: string
  belongCorpName: string
  createdTime: string
  thirdParty: string
  sourceLabel: string
  takeoverStatus: number
}

interface DingUser {
  userName: string
}

interface Company {
  name: string
  corPid?: string | number
  corpId?: string | number
  id?: string | number
}

export interface TransferTipFilterOptions {
  usedBy: DingUser[]
  companies: Company[]
  channels: string[]
  thirdParties: string[]
}

function requireArray<T>(payload: unknown, label: string): T[] {
  if (!Array.isArray(payload)) throw new Error(`${label}响应必须是数组`)
  return payload as T[]
}

export async function fetchTransferTipPage(
  query: PageQuery<TransferTipFilters>,
  signal: AbortSignal
): Promise<PageResult<TransferTipRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/transferTip/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<TransferTipRecord>(payload)
}

export async function fetchTransferTipFilterOptions(): Promise<TransferTipFilterOptions> {
  const [usedBy, companies, channels, thirdParties] = await Promise.all([
    requestV2.get<unknown>({
      url: '/main/enterpriseWechat/dingUser/listAll'
    }),
    requestV2.get<unknown>({
      url: '/main/enterpriseWechat/config/listAll'
    }),
    requestV2.get<unknown>({
      url: '/main/customerChannel/queryAllChannel'
    }),
    requestV2.get<unknown>({
      url: '/main/customerChannel/queryThirdParty'
    })
  ])

  return {
    usedBy: requireArray<DingUser>(usedBy, '使用人列表'),
    companies: requireArray<Company>(companies, '主体列表'),
    channels: requireArray<string>(channels, '来源渠道列表'),
    thirdParties: requireArray<string>(thirdParties, '第三方列表')
  }
}
